export function formatErrorMessages(value: unknown): string {
  if (value == null) return "";

  let parsedValue: unknown = value;
  if (typeof value === "string") {
    const trimmed = value.trim();
    try {
      parsedValue = JSON.parse(trimmed);
    } catch {
      if (trimmed === "{}" || trimmed === "[]") return "";
      return value;
    }
  }

  if (Array.isArray(parsedValue) && parsedValue.length === 0) return "";
  if (
    parsedValue &&
    typeof parsedValue === "object" &&
    Object.keys(parsedValue as Record<string, unknown>).length === 0
  ) {
    return "";
  }

  const serialized = JSON.stringify(parsedValue, null, 2);
  const lines = serialized.split("\n");
  if (
    lines.length >= 2 &&
    /^[\{\[]\s*$/.test(lines[0]) &&
    /^[\}\]]\s*$/.test(lines[lines.length - 1])
  ) {
    lines.shift();
    lines.pop();
    return lines
      .map((line) => line.replace(/^ {2}/, ""))
      .join("\n")
      .trimEnd();
  }

  return serialized;
}
